import request from '@/utils/request'

//Login
export function loadPaginatedRebates(param) {
  return request({ url: 'vmyrebates', method: 'post', data: param })
} 
